/**
 * Opens the BF Size Charts app trigger from our custom Size Guide link.
 */
(function () {
  function findSizeChartTrigger(root) {
    return root.querySelector(
      '.best-fit-size-chart a, .best-fit-size-chart button, [class*="best-fit-size"] a, [class*="best-fit-size"] button, [id*="bf_size"] a, [id*="bf_size"] button, shopify-app-block[id*="bf_size"] a, shopify-app-block[id*="bf_size"] button'
    );
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lm-size-guide-trigger]');
    if (!link) return;

    event.preventDefault();

    const root = link.closest('product-info') || document;
    const trigger = findSizeChartTrigger(root);

    if (trigger) {
      trigger.click();
      return;
    }

    const fallback = document.querySelector(
      '.best-fit-size-chart a, .best-fit-size-chart button, [class*="best-fit-size"] a, [class*="best-fit-size"] button'
    );
    fallback?.click();
  });
})();
